import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { horoscopeFetchData } from '../../../redux/actions/horoscopeAction';
import { homePrimaryFetchData } from '../../../redux/actions/homePrimaryAction';
import './RashifalPage.css';

const RashifalPage = () => {
    const dispatch = useDispatch();

    let navigate = useNavigate();
    const location = useLocation();
    const isHome = location.pathname === "/";
    // Data from Redux
    const Horoscope = useSelector((state) => state?.HoroscopeReducer?.data);

    const { 21: assetbaseUrl } = useSelector((state) => state?.SettingReducer?.data || {});

    // State for featured/active pick
    const [activeSign, setActiveSign] = useState(null);

    useEffect(() => {
        dispatch(homePrimaryFetchData());
        dispatch(horoscopeFetchData());
    }, [dispatch]);

    useEffect(() => {
        if (Horoscope && Horoscope.length > 0) {
            setActiveSign(Horoscope[4] || Horoscope[0]);
        }
    }, [Horoscope]);

    const handleSignClick = (sign) => {
        setActiveSign(sign);
        navigate(`/astrology/${sign?.url}/daily`);
    };

    const handleTarotClick = (sign) => {
        navigate(`/astrology/${sign?.url}/tarot`);
    };

    const handleNumerologyClick = (num) => {
        navigate(`/astrology/${num}`);
    };

    // Define visibility flags to keep layout and rendering in sync
    const showAstrology = Horoscope && Horoscope?.data_status?.astrology === "success" && !isHome;
    const showNumerology = Horoscope && Horoscope?.data_status?.numerology === "success";
    const showTarot = Horoscope && Horoscope?.data_status?.tarot === "success";

    const activeSections = [showAstrology, showNumerology, showTarot].filter(Boolean).length;

    const content = (
        <div className={`astro-dashboard-grid ${isHome ? 'is-home' : ''} active-sections-${activeSections}`}>

            {/* Column 1: Rashifal Grid */}
            {showAstrology && (
                <section className="astro-section">
                    <div className="celestial-header">
                        <h2 className="celestial-title">રાશિફળ</h2>
                        <div className="celestial-divider">
                            <span className="divider-line"></span>
                            <span className="divider-icon star-icon">✦</span>
                            <span className="divider-line"></span>
                        </div>
                        <span className="celestial-subtitle">CELESTIAL DASHBOARD</span>
                    </div>

                    <div className="astro-card-main">
                        <div className="zodiac-grid">

                            {Horoscope?.Astrology?.map((sign, idx) => (
                                <div
                                    key={idx}
                                    onClick={() => handleSignClick(sign)}
                                    className={`zodiac-item ${activeSign?.name_guj === sign.name_guj}`}
                                >
                                    <div className="zodiac-img-wrap">
                                        <img
                                            src={`${assetbaseUrl?.value}${sign?.media}`}
                                            alt={sign?.name_guj}
                                        />
                                    </div>
                                    <span className="zodiac-name">{sign?.name_guj}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            )}



            {/* Column 2: Numerology Matrix */}
            {showNumerology && (
                <section className="astro-section">
                    <div className="celestial-header">
                        <h2 className="celestial-title">અંક ભવિષ્ય</h2>
                        <div className="celestial-divider">
                            <span className="divider-line"></span>
                            <span className="divider-icon moon-icon">🌙</span>
                            <span className="divider-line"></span>
                        </div>
                        <span className="celestial-subtitle">NUMEROLOGY MATRIX</span>
                    </div>
                    <div className="astro-card-main">
                        <div className="numerology-grid">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                                <div
                                    key={num}
                                    onClick={() => handleNumerologyClick(num)}
                                    className="zodiac-item"
                                    data-number={num}
                                >
                                    <div className="number-box">
                                        {num}
                                    </div>
                                    <span className="zodiac-name">અંક {num}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            )}

            {/* Column 3: Taro Insights List */}
            {showTarot && (
                <section className="astro-section tarot-section">
                    <div className="celestial-header">
                        <h2 className="celestial-title">ટેરો રાશિફળ</h2>
                        <div className="celestial-divider">
                            <span className="divider-line"></span>
                            <span className="divider-icon pointer-icon">▲</span>
                            <span className="divider-line"></span>
                        </div>
                        <span className="celestial-subtitle">TAROT WISDOM</span>
                    </div>

                    <div className="astro-card-main">
                        <div className="zodiac-grid">
                            {Horoscope?.Tarot?.map((sign, idx) => (
                                <div
                                    key={idx}
                                    onClick={() => handleTarotClick(sign)}
                                    className={`zodiac-item ${activeSign?.name_guj === sign.name_guj ? 'active' : ''}`}
                                >
                                    <div className="zodiac-img-wrap" style={{ aspectRatio: '2/3', height: '70px', width: 'auto' }}>
                                        <img
                                            src={`${assetbaseUrl?.value}${sign.media}`}
                                            alt={sign.name_guj}

                                        />
                                    </div>
                                    <span className="zodiac-name" style={{ fontSize: '11px', marginTop: '8px' }}>{sign.name_guj}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            )}
        </div>
    );

    if (isHome) {
        return content;
    }

    return (
        <div className="rashifal-premium-page celestial-aurora">
            <div className="astro-container">
                {content}
            </div>
        </div>
    );
};

export default RashifalPage;
